import { Role } from '@ndvr/auth-api';

import { useActiveRoles } from 'views/admin/internalUserProfiles/role-queries';
import { useAuthContext } from 'views/auth/Auth';

export const useCmsPermissions = () => {
    const { user } = useAuthContext();
    const rolesQuery = useActiveRoles(user?.personOrgGUID || '');
    const roles = rolesQuery.data?.map((activeRole) => activeRole.role) ?? [];

    const canAdmin = roles.includes(Role.CMS_ADMIN);
    const canEditMicrosite = (ownerUserGUID?: string) =>
        canAdmin || (!!ownerUserGUID && ownerUserGUID === user?.profileGUID);

    return {
        canEdit: canAdmin,
        canEditMicrosite,
        canCreateMicrosite: canAdmin || !!user?.profileGUID,
        canReview: canAdmin || roles.includes(Role.CMS_REVIEW),
        canPublish: canAdmin,
        canSelfApprove: canAdmin && roles.includes(Role.CMS_REVIEW),
        canAdmin,
        isLoading: rolesQuery.isLoading,
    };
};
